import React, { useState, useEffect, Fragment } from "react";
import dayjs from "dayjs";
import { useSelector } from "react-redux";

import { styled } from "@mui/styles";

import { Typography, Button, Grid, IconButton, Divider } from "@mui/material";

import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import EditRoundedIcon from "@mui/icons-material/EditRounded";

import ModalShowmap from "./showMap/index.js";
import siteService from "../../../../../services/site.service.js";

require("dayjs/locale/th");
dayjs.locale("th");

const DivCoverReturn = styled("div")(({ theme }) => ({
  width: "100%",
  marginTop: "20px",
  position: "relative",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
}));

const BackButton = styled(Button)(({ theme }) => ({
  position: "absolute",
  color: "black",
  fontSize: "20px",
  left: "40px",
}));

const EditButton = styled(IconButton)(({ theme }) => ({
  position: "absolute",
  color: "black",
  fontSize: "20px",
  right: "50px",
}));

const Title = styled(Typography)(({ theme }) => ({
  textAlign: "center",
  fontSize: "30px",
}));

const DivContent = styled("div")(({ theme }) => ({
  width: "90%",
  maxWidth: "1100px",
  boxShadow:
    "rgb(145 158 171 / 24%) 0px 0px 2px 0px, rgb(145 158 171 / 24%) 0px 16px 32px -4px",
  border: "1px solid #EEEEEE",
  backgroundColor: "#FBFCFC",
  borderRadius: "15px",
  padding: "20px",
  marginBottom: "50px",
}));

const DivTopic = styled("div")(({ theme }) => ({
  display: "flex",
  borderBottom: "1px solid #1565c0",
  marginTop: "24px",
}));

const TextMainTopic = styled(Typography)(({ theme }) => ({
  fontSize: "20px",
  fontWeight: "bold",
  color: theme.palette.text.primary,
}));

const TextTopic = styled(Typography)(({ theme }) => ({
  fontSize: "18px",
  fontWeight: "bold",
}));

const TextData = styled(Typography)(({ theme }) => ({
  fontSize: "18px",
  marginLeft: "5px",
  color: theme.palette.text.primary,
}));

const DivTopicAndData = styled("div")(({ theme }) => ({
  display: "flex",
}));

const GridContainer = styled(Grid)(({ theme }) => ({
  width: "100%",
  marginTop: "0px",
}));

const DivTypeOfFlight = styled("div")(({ theme }) => ({
  width: "calc(100% - 68px)",
  marginTop: "24px",
}));

const DivTextFlight = styled("div")(({ theme }) => ({
  width: "100%",
  borderBottom: "1px solid #DCDCDC",
  marginTop: "24px",
}));

const DivPurpose = styled("div")(({ theme }) => ({
  width: "calc(100% - 68px)",
  marginTop: "24px",
}));

const DivMap = styled("div")(({ theme }) => ({
  width: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  marginTop: "24px",
}));

const DivGettingPlace = styled("div")(({ theme }) => ({
  width: "calc(100% - 68px)",
  marginTop: "24px",
}));
const ViewButton = styled(Button)({
  border: "1px solid #00bb77",
  width: "100%",
  fontSize: "20px",
  // backgroundColor: "#3970C2",
  color: "#00bb77",
});

const DetailCrossAreaCarPool = (props) => {
  const {
    result: AllBookingCrossAreaPool,
    isFetching: isFetchingCrossAreaPool,
  } = useSelector((state) => state.crossAreaCarPool);
  const [booking, setBooking] = useState(null);
  const [car, setCar] = useState(null);
  const [passenger, setPassenger] = useState(null);
  const [isUserApproved, setUserApproved] = useState(null);
  const [isEmployee, setEmployee] = useState(null);
  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    if (props.location.state === undefined) {
      props.history.push("/admin/car_management");
    } else {
      let booking_temp = AllBookingCrossAreaPool.filter(
        (item) => item.idCrossAreaCarPoolBooking === props.location.state.id
      );

      siteService
        .getLocationDriverById(booking_temp[0].idDriver)
        .then((res) => {
          if (res.data) {
            booking_temp[0].LatDriver = res.data[0].LatDriver;
            booking_temp[0].LngDriver = res.data[0].LngDriver;
            setBooking(booking_temp[0]);
          }
        })
        .catch((error) => {
          booking_temp[0].LatDriver = 0;
          booking_temp[0].LngDriver = 0;
          setBooking(booking_temp[0]);
          console.log(error);
        });
      let passenger_temp = [];
      for (let i = 0; i < booking_temp[0].routes.length; i++) {
        passenger_temp.push(booking_temp[0].routes[i]);
      }
      setPassenger(passenger_temp);
      if (booking_temp[0].vehicle) {
        setCar(booking_temp[0].vehicle);
      } else {
        if (
          booking_temp[0].isDriverFromCompany !== true ||
          booking_temp[0].statusManageCar !== "Success"
        ) {
          setCar([]);
        }
      }
    }
  }, [props.location.state]);

  console.log(props.location.state);
  console.log(booking);
  const onCloseModalHandle = () => {
    setOpenModal(false);
  };

  const onClickOpenModal = () => {
    setOpenModal(true);
  };

  return (
    <>
      {booking && (!booking.isDriverFromCompany || car) && passenger && (
        <DivCoverReturn>
          <BackButton onClick={() => props.history.goBack()}>
            <ArrowBackIosNewIcon /> Back
          </BackButton>
          <Title>จองรถข้ามพื้นที่เฉพาะPool</Title>
          {/* // <DivCoverContent> */}
          <EditButton
            onClick={() =>
              props.history.push(
                "/admin/car_management/cross_area_pool/edit_detail",
                {
                  booking: booking,
                }
              )
            }
          >
            <EditRoundedIcon />
          </EditButton>
          <DivContent>
            <DivTopic>
              <TextMainTopic>ผู้จอง</TextMainTopic>
            </DivTopic>
            <GridContainer container spacing={3}>
              <Grid item xs={12} sm={6} md={4} lg={4}>
                <DivTopicAndData>
                  <TextTopic>ชื่อ :</TextTopic>
                  <TextData>{booking.name}</TextData>
                </DivTopicAndData>
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={4}>
                <DivTopicAndData>
                  <TextTopic>เบอร์โทรศัพท์ :</TextTopic>
                  <TextData>{booking.telephoneMobile}</TextData>
                </DivTopicAndData>
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={4}>
                <DivTopicAndData>
                  <TextTopic>Email :</TextTopic>
                  <TextData>{booking.email}</TextData>
                </DivTopicAndData>
              </Grid>
            </GridContainer>
            <DivTopic>
              <TextMainTopic>รายละเอียดการจอง</TextMainTopic>
            </DivTopic>
            <DivTypeOfFlight>
              <DivTopicAndData>
                <TextTopic>ประเภทการเดินทาง :</TextTopic>
                <TextData>
                  {booking.flight === "oneWay" ? "เที่ยวเดียว" : "ไป-กลับ"}
                </TextData>
              </DivTopicAndData>
            </DivTypeOfFlight>
            {booking.flight === "twoWay" && (
              <DivTextFlight>
                <TextTopic>ขาไป</TextTopic>
              </DivTextFlight>
            )}
            <GridContainer container spacing={3}>
              <Grid item xs={12} sm={6} md={6} lg={4}>
                <DivTopicAndData>
                  <TextTopic>ต้นทาง :</TextTopic>
                  <TextData>{booking.fromPlace}</TextData>
                </DivTopicAndData>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={4}>
                <DivTopicAndData>
                  <TextTopic>ปลายทาง :</TextTopic>
                  <TextData>{booking.toPlace}</TextData>
                </DivTopicAndData>
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={4}>
                <DivTopicAndData>
                  <TextTopic>จำนวนผู้โดยสาร :</TextTopic>
                  <TextData>{booking.numberOfPassenger}</TextData>
                </DivTopicAndData>
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={4}>
                <DivTopicAndData>
                  <TextTopic>วันที่เดินทาง :</TextTopic>
                  <TextData>
                    {dayjs(booking.departureDate).format("DD MMMM YYYY")}
                  </TextData>
                </DivTopicAndData>
              </Grid>
              {/* <Grid item md={4}>
                <DivTopicAndData>
                  <TextTopic>เวลาเริ่มออกรถ :</TextTopic>
                  <TextData>
                    {dayjs(booking.startTime).format("HH.mm น.")}
                  </TextData>
                </DivTopicAndData>
              </Grid>
              <Grid item md={4}>
                <DivTopicAndData>
                  <TextTopic>เวลาคืนรถ :</TextTopic>
                  <TextData>
                    {dayjs(booking.endTime).format("HH.mm น.")}
                  </TextData>
                </DivTopicAndData>
              </Grid> */}
            </GridContainer>
            {booking.flight === "twoWay" && (
              <>
                <DivTextFlight>
                  <TextTopic>ขากลับ</TextTopic>
                </DivTextFlight>
                <GridContainer container spacing={3}>
                  <Grid item xs={12} sm={6} md={6} lg={4}>
                    <DivTopicAndData>
                      <TextTopic>ต้นทาง :</TextTopic>
                      <TextData>{booking.fromPlaceReturn}</TextData>
                    </DivTopicAndData>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={4}>
                    <DivTopicAndData>
                      <TextTopic>ปลายทาง :</TextTopic>
                      <TextData>{booking.toPlaceReturn}</TextData>
                    </DivTopicAndData>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} lg={4}>
                    <DivTopicAndData>
                      <TextTopic>จำนวนผู้โดยสาร :</TextTopic>
                      <TextData>{booking.numberOfPassengerReturn}</TextData>
                    </DivTopicAndData>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} lg={4}>
                    <DivTopicAndData>
                      <TextTopic>วันที่เดินทาง :</TextTopic>
                      <TextData>
                        {dayjs(booking.returnDate).format("DD MMMM YYYY")}
                      </TextData>
                    </DivTopicAndData>
                  </Grid>
                  {/* <Grid item md={4}>
                    <DivTopicAndData>
                      <TextTopic>เวลาเริ่มออกรถ :</TextTopic>
                      <TextData>
                        {dayjs(booking.returnStartTime).format("HH.mm น.")}
                      </TextData>
                    </DivTopicAndData>
                  </Grid>
                  <Grid item md={4}>
                    <DivTopicAndData>
                      <TextTopic>เวลาคืนรถ :</TextTopic>
                      <TextData>
                        {dayjs(booking.returnEndTime).format("HH.mm น.")}
                      </TextData>
                    </DivTopicAndData>
                  </Grid> */}
                </GridContainer>
              </>
            )}
            {/* <DivPurpose>
              <DivTopicAndData>
                <TextTopic>วัตถุประสงค์ :</TextTopic>
                <TextData>{booking.purpose}</TextData>
              </DivTopicAndData>
            </DivPurpose> */}
            {booking.statusManageCar === "Success" ? (
              <>
                <DivTopic>
                  <TextMainTopic>
                    {booking.isDriverFromCompany
                      ? "รายละเอียดรถยนต์ในบริษัท"
                      : "รายละเอียดรถยนต์จากบริษัทอื่น"}
                  </TextMainTopic>
                </DivTopic>
                <GridContainer container spacing={3}>
                  {booking.isDriverFromCompany ? (
                    <>
                      <Grid item xs={12} sm={6} md={4} lg={4}>
                        <DivTopicAndData>
                          <TextTopic>ยี่ห้อ :</TextTopic>
                          <TextData>{car.brand}</TextData>
                        </DivTopicAndData>
                      </Grid>
                      <Grid item xs={12} sm={6} md={4} lg={4}>
                        <DivTopicAndData>
                          <TextTopic>รุ่น :</TextTopic>
                          <TextData>{car.model}</TextData>
                        </DivTopicAndData>
                      </Grid>
                    </>
                  ) : null}
                  <Grid item xs={12} sm={6} md={4} lg={4}>
                    <DivTopicAndData>
                      <TextTopic>ทะเบียนรถ :</TextTopic>
                      <TextData>{booking.plate_No}</TextData>
                    </DivTopicAndData>
                  </Grid>
                  {booking.isDriverFromCompany ? (
                    <Grid item xs={12} sm={6} md={4} lg={4}>
                      <DivTopicAndData>
                        <TextTopic>จำนวนที่นั่ง :</TextTopic>
                        <TextData>{car.capacity}</TextData>
                      </DivTopicAndData>
                    </Grid>
                  ) : null}
                </GridContainer>
              </>
            ) : null}
            <DivTopic>
              <TextMainTopic>รายละเอียดผู้โดยสาร</TextMainTopic>
            </DivTopic>
            {/* <DivGettingPlace>
              <DivTopicAndData>
                <TextTopic>ประเภทจุดรับ :</TextTopic>
                <TextData>
                  {booking.gettingPoint === "onePoint"
                    ? "จุดเดียว"
                    : "รับรายคน"}
                </TextData>
              </DivTopicAndData>
            </DivGettingPlace> */}

            {passenger.map((passen, index) => (
              <Fragment key={passen.idCrossAreaCarPoolBookingPassenger}>
                {booking.gettingPoint === "manyPoint" && (
                  <TextTopic
                    style={{
                      marginTop: "24px",
                      borderBottom: "1px solid #DCDCDC",
                    }}
                  >
                    ผู้โดยสารคนที่ {index + 1}
                  </TextTopic>
                )}
                <GridContainer container spacing={3}>
                  {index !== 0 && (
                    <Grid item md={12}>
                      <Divider style={{ width: "100%" }} />
                    </Grid>
                  )}
                  <Grid item xs={12} sm={6} md={4} lg={4}>
                    <DivTopicAndData>
                      <TextTopic>ชื่อ :</TextTopic>
                      <TextData>{passen.detail.name}</TextData>
                    </DivTopicAndData>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} lg={4}>
                    <DivTopicAndData>
                      <TextTopic>เบอร์โทรศัพท์ :</TextTopic>
                      <TextData>{passen.detail.telephoneMobile}</TextData>
                    </DivTopicAndData>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} lg={4}>
                    <DivTopicAndData>
                      <TextTopic>Email :</TextTopic>
                      <TextData>{passen.detail.email}</TextData>
                    </DivTopicAndData>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} lg={4}>
                    <DivTopicAndData>
                      <TextTopic>บริษัท :</TextTopic>
                      <TextData>{passen.detail.company}</TextData>
                    </DivTopicAndData>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} lg={4}>
                    <DivTopicAndData>
                      <TextTopic>Cost Center :</TextTopic>
                      <TextData>{passen.detail.costCenter}</TextData>
                    </DivTopicAndData>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} lg={4}>
                    <DivTopicAndData>
                      <TextTopic>Cost Element :</TextTopic>
                      <TextData>{passen.detail.costElement}</TextData>
                    </DivTopicAndData>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <DivTopicAndData>
                      <TextTopic>จุดรับ :</TextTopic>
                      <TextData>{passen.detail.fromPlace}</TextData>
                    </DivTopicAndData>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <DivTopicAndData>
                      <TextTopic>เวลารับ :</TextTopic>
                      <TextData>{passen.detail.roundTime + " น."}</TextData>
                    </DivTopicAndData>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <DivTopicAndData>
                      <TextTopic>จุดส่ง :</TextTopic>
                      <TextData>{passen.detail.toPlace}</TextData>
                    </DivTopicAndData>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <DivTopicAndData>
                      <TextTopic>เวลาส่ง :</TextTopic>
                      <TextData>{passen.detail.endTime + " น."}</TextData>
                    </DivTopicAndData>
                  </Grid>
                  {booking.flight === "twoWay" && (
                    <>
                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        <DivTopicAndData>
                          <TextTopic>จุดรับขากลับ :</TextTopic>
                          <TextData>{passen.detail.fromPlaceReturn}</TextData>
                        </DivTopicAndData>
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        <DivTopicAndData>
                          <TextTopic>เวลารับ :</TextTopic>
                          <TextData>
                            {passen.detail.roundTimeReturn + " น."}
                          </TextData>
                        </DivTopicAndData>
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        <DivTopicAndData>
                          <TextTopic>จุดส่งขากลับ :</TextTopic>
                          <TextData>{passen.detail.toPlaceReturn}</TextData>
                        </DivTopicAndData>
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        <DivTopicAndData>
                          <TextTopic>เวลาส่ง :</TextTopic>
                          <TextData>
                            {passen.detail.endTimeReturn + " น."}
                          </TextData>
                        </DivTopicAndData>
                      </Grid>
                    </>
                  )}
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <DivTopicAndData>
                      <TextTopic>วัตถุประสงค์ :</TextTopic>
                      <TextData>{passen.detail.purpose}</TextData>
                    </DivTopicAndData>
                  </Grid>
                </GridContainer>
              </Fragment>
            ))}
            {/* <DivTopic>
              <TextMainTopic>ผู้อนุมัติ</TextMainTopic>
            </DivTopic>
            {isEmployee && (
              <Fragment key={isEmployee[0].idEmployees}>
                <GridContainer container spacing={3}>
                  <Grid item xs={12} sm={6} md={6} lg={4}>
                    <DivTopicAndData>
                      <TextTopic>ชื่อคนอนุมัติ :</TextTopic>
                      <TextData>{isEmployee[0].firstname_TH}</TextData>
                    </DivTopicAndData>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={4}>
                    <DivTopicAndData>
                      <TextTopic>แผนกของคนอนุมัติ :</TextTopic>
                      <TextData>{isEmployee[0].departmentName}</TextData>
                    </DivTopicAndData>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={4}>
                    <DivTopicAndData>
                      <TextTopic>บริษัทของคนอนุมัติ :</TextTopic>
                      <TextData>{isEmployee[0].companyName}</TextData>
                    </DivTopicAndData>
                  </Grid>
                  
                </GridContainer>
              </Fragment>
            )} */}
            <DivMap>
              <ViewButton onClick={onClickOpenModal}>แสดงแผนที่</ViewButton>
            </DivMap>
          </DivContent>
          <ModalShowmap
            open={openModal}
            onCloseHandle={onCloseModalHandle}
            inforInCar={booking}
          />
        </DivCoverReturn>
      )}
    </>
  );
};

export default DetailCrossAreaCarPool;
